import React from 'react';

const BorderButton = ({ label }) => (
  <button className="border_button">
    {label}
  </button>
);

export default BorderButton;